import manager from 'app/module46/component-manager.js';
import Dropzone from "dropzone";
import Sortable from 'sortablejs';
import Swal from "sweetalert2";


manager.register('dropzone-form', (component, elements, attributes, properties) => {
	const {
		images,
		orderUrl,
		deleteUrl,
		listUrl
	} = properties;

	const {
		previewTemplate,
		previewsContainer,
		dropzone,
		imageZoomTemplate
	} = elements;

	let dropzoneComponent = new Dropzone(dropzone, {
		acceptedFiles: 'image/*',
		// addRemoveLinks:  true,
		previewTemplate:   previewTemplate.innerHTML,
		previewsContainer: previewsContainer,
		thumbnailWidth:    141,
		thumbnailHeight:   141,
		// disablePreviews: true,
	});

	const showSmallLoader = () => {
		Swal.fire({
			position:          "bottom-end",
			loading:           true,
			showCloseButton:   false,
			showConfirmButton: false,
			toast:             true,
			customClass:       {
				popup: "panel-box"
			}
		});
		Swal.showLoading();
	};

	dropzoneComponent.on("addedfile", file => {
		file.previewElement.dataset.id = file.id;
	});

	let i = 0;
	for (const image of images) {
		const path = image.photo_image;
		const pathArr = path.split('/');
		const name = pathArr[pathArr.length - 1];

		let mockFile = {name, size: 12345, id: image.id};

		dropzoneComponent.displayExistingFile(mockFile, image.photo_image);
	}


	dropzoneComponent.on("success", (file, response, e) => {
		// After uploading file, server responds with id
		// We add it to the object file for reference.
		file.id = response.id;
		file.previewElement.dataset.id = file.id;
	});

	dropzoneComponent.on("removedfile", file => {
		const id = file.id;

		// Ask server to delete
		showSmallLoader();

		manager.api(deleteUrl, {
			imageId: id
		});
	});

	const sortable = Sortable.create(previewsContainer, {
		sort:      true,
		cursor:    'move',
		draggable: '.dz-preview',
		handle:    '.drag-icon',
		onEnd:     (evt) => {
			const images = sortable.toArray();
			const formData = new FormData;

			for (const image of images) {
				formData.append('images[]', image);
			}

			showSmallLoader();
			manager.api(orderUrl, formData);
		}
	});

	component.addEventListener('click', (event) => {
		let preview;

		if (event.target.closest('.dz-image') && (preview = event.target.closest('.dz-complete'))) {
			const imageId = preview.dataset.id;
			let currIndex;


			Swal.showLoading();

			manager.get(listUrl, ({images}) => {
				currIndex = images.findIndex(image => +image.id === +imageId);
				const max = images.length - 1;

				const html = imageZoomTemplate.innerHTML;
				Swal.fire({
					html,
					showCloseButton:   true,
					showCancelButton:  false,
					showConfirmButton: false,
					willOpen:          (popup) => {
						console.log(popup);
						const imageContainer = popup.querySelector('[data-ref=imageContainer]');
						const prevBtn = popup.querySelector('[data-ref=prevBtn]');
						const nextBtn = popup.querySelector('[data-ref=nextBtn]');

						const updateImage = () => {
							const image = images[currIndex];
							imageContainer.src = image.photo_image;
						};

						const updateBtns = () => {
							if (currIndex === 0) {
								prevBtn.style.display = 'none';
							} else {
								prevBtn.style.removeProperty('display');
							}

							if (currIndex === max) {
								nextBtn.style.display = 'none';
							} else {
								nextBtn.style.removeProperty('display');
							}
						};

						const updatePanel = () => {
							updateBtns();
							updateImage();
						};

						prevBtn.addEventListener('click', () => {
							if (currIndex !== 0) {
								currIndex--;

								updatePanel();
							}
						});

						nextBtn.addEventListener('click', () => {
							if (currIndex !== max) {
								currIndex++;

								updatePanel();
							}
						});

						updatePanel();
					}
				});

			}, () => {
				// TODO error message
				Swal.close();
			});
		}
	});
});
